import React from 'react';
import { makeStyles } from '@material-ui/core';
import { usePracticeModuleData } from "examsbook-react-sdk/custom-hooks";
import SingleSubjectItem from "./SingleSubjectItem";
import SubjectsListLoader from "../common/loaders/SubjectsListLoader";

/**
 * Practice test entry point.
 * @param props
 * @returns {*}
 * @constructor
 */
function PracticeTab(props) {
    const classes = useStyles();
    const { subjects, subjectsLoading } = usePracticeModuleData();
    return (
        <div className={classes.practiceTabContainer}>
            <div className={classes.heading}>
                <h4>What do you want to <span>practice</span> today ?</h4>
            </div>
            <div className={classes.testListing}>
                <ul>
                    {
                        !subjectsLoading ? <>{
                            subjects.map((subject) => {
                                return (
                                    <SingleSubjectItem key={subject._id} subject={subject}/>
                                );
                            })
                        }</> : <SubjectsListLoader/>
                    }
                </ul>
            </div>
        </div>
    );
}

const useStyles = makeStyles(theme => ({
    practiceTabContainer: {},
    heading: {
        widh: '100%',
        display: 'flex',
        justifyContent: 'center',
        '& h4': {
            fontSize: '24px',
            fontWeight: 'bold',
            textAlign: 'center',
            color: '#000',
            margin: 0,
            marginBottom: 30,
            '& span': {
                color: '#008E76'
            }
        }
    },
    testListing: {
        '& ul': {
            margin: 0,
            padding: 0,
            '& li': {
                display: 'flex',
                alignItems: 'center',
                marginBottom: 30,
            }
        }
    }
}));

export default PracticeTab;
